import {
	FontFamily,
	WEIGHT_WORD_MAP,
	WIDTH_WORD_MAP,
} from "csi/utility/fontUtility";
import _ from "lodash";

const FONT_FAMILIES: Record<string, FontFamily> = {
	Centric8: "Centric8",
	"Arial,Helvetica,sans-serif": "Arial",
	"Georgia,serif": "Georgia",
	"Impact,Charcoal,sans-serif": "Impact",
	"Tahoma,Geneva,sans-serif": "Tahoma",
	"Times New Roman,Times,serif,-webkit-standard": "Times New Roman",
	"Verdana,Geneva,sans-serif": "Verdana",
};

const FONT_FAMILY_WEIGHT_MAP: Record<string, number[]> = {};

/**
 * Merge font families into unique FontFamily[] array.
 */
export function setFontFamilies(fontFamilies: FontFamily[]): void {
	for (const family of fontFamilies) {
		FONT_FAMILIES[family] = family;
	}
};

/**
 * Add supported weights with `${FontFamily}${FontStyle}` as the key and the number array of weights as the value.
 */
export function setFontWeights(key: string, weightWords: number[] | string): void {
	if (typeof weightWords === "string") {
		weightWords = [parseInt(weightWords)];
	}
	const allWeightsWithThisKey = getFontWeights(key)
		.concat(weightWords);
	FONT_FAMILY_WEIGHT_MAP[key] = _.uniq(allWeightsWithThisKey);
};

/**
 * Get the font weights by key.
 */
export function getFontWeights(key: string): number[] {
	return FONT_FAMILY_WEIGHT_MAP[key] || [];
};

/**
 * Get all font families for Froala.
 */
export function getFontFamilies(): Record<string, FontFamily> {
	return FONT_FAMILIES;
};

/**
 * Get all font family names.
 */
export function getFontFamilyNames(): FontFamily[] {
	return Object.values(FONT_FAMILIES);
}

/**
 * Return all system weight options.
 */
export function getAllWeights(): string[] {
	return Object.keys(WEIGHT_WORD_MAP);
};

/**
 * Return all system width (font stretch) options.
 */
export function getAllWidths(): string[] {
	return Object.keys(WIDTH_WORD_MAP);
};
